import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 120px var(--space-md) 80px;
  text-align: center;
`;

const ErrorCode = styled.h1`
  font-size: 8rem;
  font-weight: 700;
  color: var(--primary-600);
  margin-bottom: var(--space-lg);

  @media (max-width: 768px) {
    font-size: 5rem;
  }
`;

const ErrorTitle = styled.h2`
  font-size: 2rem;
  margin-bottom: var(--space-lg);
  color: var(--secondary-900);
`;

const ErrorDescription = styled.p`
  font-size: 1.125rem;
  color: var(--secondary-600);
  margin-bottom: var(--space-2xl);
  line-height: 1.6;
`;

const HomeButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: var(--space-sm);
  background: var(--primary-600);
  color: white;
  padding: var(--space-md) var(--space-xl);
  border-radius: var(--radius-lg);
  font-weight: 600;
  text-decoration: none;
  transition: all var(--transition-fast);

  &:hover {
    background: var(--primary-700);
    transform: translateY(-2px);
    box-shadow: var(--shadow-lg);
  }
`;

const NotFoundPage = () => {
  return (
    <Container>
      <ErrorCode>404</ErrorCode>
      <ErrorTitle>Page Not Found</ErrorTitle>
      <ErrorDescription>
        The page you're looking for doesn't exist. It might have been moved, 
        deleted, or you entered the wrong URL.
      </ErrorDescription>
      <HomeButton to="/">
        <FaHome />
        Go Home
      </HomeButton>
    </Container>
  );
};

export default NotFoundPage;